export enum AgentCode {
  App = 'APP',
  MobileWeb = 'MOBILE_WEB',
  PcWeb = 'PC_WEB',
}
